/**
 * Centralized route path constants.
 * Single source of truth for all route paths in the application.
 */
import {UserRole} from '@/shared/types/common.ts';

export const ROUTE_PATHS = {
    ROOT: '/',
    LOGIN: '/login',

    // Receptionist routes
    RECEPTIONIST: {
        ROOT: '/recepcionista',
        PAGAMENTO: '/recepcionista/pagamento',
        PAGAMENTOS_PENDENTES: '/recepcionista/pagamentos-pendentes',
        CLIENTES: '/recepcionista/clientes',
        EDITAR: '/recepcionista/editar',
    },

    // Employee routes
    EMPLOYEE: {
        ROOT: '/profissional',
        RESUMO: '/profissional/resumo',
        FECHAMENTO: '/profissional/fechamento',
        PAGAMENTOS_PENDENTES: '/profissional/pagamentos-pendentes',
    },

    // Owner routes
    OWNER: {
        ROOT: '/admin',
        SALDO: '/admin/saldo',
        DIARIO: '/admin/diario',
        COMISSAO: '/admin/comissao',
        FLUXO: '/admin/fluxo',
        CLIENTES: '/admin/clientes',
        PAGAMENTOS_PENDENTES: '/admin/pagamentos-pendentes',
    },
} as const;

/**
 * Get the default route for a given user role.
 */
export const getDefaultRouteForRole = (role: UserRole): string => {
    switch (role) {
        case 'receptionist': {
            return ROUTE_PATHS.RECEPTIONIST.PAGAMENTO;
        }
        case 'employee': {
            return ROUTE_PATHS.EMPLOYEE.RESUMO;
        }
        case 'owner': {
            return ROUTE_PATHS.OWNER.CLIENTES;
        }
        default: {
            return ROUTE_PATHS.LOGIN;
        }
    }
};

/**
 * Route titles for the Header component.
 */
export const ROUTE_TITLES: Record<string, string> = {
    // Receptionist
    [ROUTE_PATHS.RECEPTIONIST.PAGAMENTO]: 'Pagamento',
    [ROUTE_PATHS.RECEPTIONIST.PAGAMENTOS_PENDENTES]: 'Pendente',
    [ROUTE_PATHS.RECEPTIONIST.CLIENTES]: 'Clientes',
    [ROUTE_PATHS.RECEPTIONIST.EDITAR]: 'Editar',

    // Employee
    [ROUTE_PATHS.EMPLOYEE.RESUMO]: 'Meu Resumo',
    [ROUTE_PATHS.EMPLOYEE.FECHAMENTO]: 'Meu Fechamento',
    [ROUTE_PATHS.EMPLOYEE.PAGAMENTOS_PENDENTES]: 'Pendente',

    // Owner
    [ROUTE_PATHS.OWNER.SALDO]: 'Saldo Atual',
    [ROUTE_PATHS.OWNER.DIARIO]: 'Fechamento Diário',
    [ROUTE_PATHS.OWNER.COMISSAO]: 'Comissão',
    [ROUTE_PATHS.OWNER.FLUXO]: 'Fluxo de Caixa',
    [ROUTE_PATHS.OWNER.CLIENTES]: 'Clientes',
    [ROUTE_PATHS.OWNER.PAGAMENTOS_PENDENTES]: 'Pendente',
};
